/* Polsk katalog for locale-bank-misc-no.js (del 3 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'bank.guided.tabHandling': 'Do przetworzenia · {{count}}',
  'bank.guided.tabDeviation': 'Powoduje różnicę · {{count}}',
  'bank.guided.postsCauseDeviation': 'Zaksięgowane zapisy powodujące różnicę: {{count}}',
  'bank.guided.linkHelp': 'Powiąż paragon lub fakturę z zakupem. Jeśli dokumentacja nie istnieje, wybierz „Bez dowodu”, aby wybór został zapisany i mógł zostać później sprawdzony.',
  'bank.guided.purchasesMissing': 'Zakupy bez dowodu: {{count}}.',
  'bank.guided.noneMissing': 'Nie brakuje żadnych dowodów.',
  'bank.guided.ctl.allHandled': 'Wszystkie płatności są przetworzone',
  'bank.guided.ctl.remaining': 'Pozostało: {{count}}',
  'bank.guided.ctl.vouchersLinked': 'Wymagane dowody są powiązane',
  'bank.guided.ctl.missingVouchers': 'Bez dowodu: {{count}}',
  'bank.guided.ctl.statementBalances': 'Salda z wyciągu bankowego się zgadzają',
  'bank.guided.ctl.deviation': 'Różnica {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Zaksięgowane saldo bankowe się zgadza',
  'bank.guided.ctl.clear': 'Gotowe',
  'bank.guided.finishNote': 'Po zakończeniu Plumme sprawdzi salda, zablokuje okres i przeniesie wyciąg do archiwum.',
  'bank.guided.allChecked': 'Wszystko sprawdzone i gotowe.',
  'bank.guided.resolveToFinish': 'Rozwiąż powyższe punkty, aby móc zakończyć.',
  'bank.guided.toast.noPending': 'Żadne propozycje nie czekają na zatwierdzenie.',
  'bank.guided.superLinks': 'SuperPlumma łączy',
  'bank.guided.approveSuggestions': 'Zatwierdź propozycje',
  'bank.guided.note.tapPurchase': 'Stuknij dowód, a następnie zakup, z którym chcesz go powiązać.',
  'bank.guided.note.tapSuggestion': 'Stuknij dowód, a następnie propozycję. Możliwe dopasowanie zostanie wyróżnione na liście.',
  'bank.guided.note.dragPurchase': 'Przeciągnij dowód na zakup, z którym chcesz go powiązać.',
  'bank.guided.note.dragSuggestion': 'Przeciągnij dowód na propozycję. Możliwe dopasowanie zostanie wyróżnione na liście.',
  'bank.guided.err.checkImportFirst': 'Najpierw sprawdź przejście importu.',
  'bank.guided.toast.postingVoided': 'Księgowanie zostało anulowane',
  'bank.guided.archiving': 'Archiwizowanie…',
  'bank.guided.archiveNote': 'Kontrola zostanie zablokowana i przeniesiona do archiwum. Pozycje bankowe zostały już zaksięgowane w chwili zatwierdzenia.',
  'bank.archive.lockedNote': 'Uzgodnienie jest zablokowane. Rozwiń pozycję, aby zobaczyć dowód i księgowanie. Konto, VAT i opis wewnętrzny można poprawić bez zmiany kwoty bankowej.',
  'bank.archive.searchPh': 'Szukaj księgowań',
  'bank.archive.searchHelp': 'Szukaj według daty, opisu, kwoty, konta lub dowodu.',
  'bank.archive.countOf': '{{shown}} z {{total}} księgowań',
  'bank.archive.handled': 'Przetworzone',
  'bank.archive.code': 'Kod {{code}}',
  'bank.archive.auditTrail': 'Ścieżka audytu',
  'bank.archive.correctionsOne': 'Korekty: {{count}}',
  'bank.archive.correctionsMany': 'Korekty: {{count}}',
  'bank.archive.noCorrections': 'Brak korekt',
  'bank.archive.internalDescription': 'Opis wewnętrzny',
  'bank.archive.noVoucher': 'Brak powiązanego dowodu',
  'bank.archive.noMatch': 'Żadne księgowania nie pasują do wyszukiwania ani filtrów.',
  'bank.archive.err.correctFailed': 'Nie udało się poprawić księgowania.',
  'bank.importFix.err.openFirst': 'Otwórz powiązanie lub księgowanie, zanim poprawisz odczyt.',
  'bank.importFix.err.reasonLine': 'Napisz krótko, dlaczego pozycja bankowa jest poprawiana.',
  'bank.importFix.err.amountNumber': 'Kwota musi być liczbą.',
  'bank.importFix.removeFromRecon': 'Ignoruj pozycję',
  'bank.importFix.warnTitle': 'Używaj tylko, jeśli PDF/CSV został odczytany błędnie.',
  'bank.importFix.warnBody': 'Nie zmienia to banku ani zaksięgowanych dowodów. Oryginalne wartości pozostają w historii.',
  'bank.importFix.blocked': 'Pozycja jest już powiązana lub zaksięgowana. Otwórz powiązanie/księgowanie, zanim poprawisz sam odczyt.',
  'bank.importFix.originalRead': 'Pierwotny odczyt',
  'bank.importFix.effect': 'Wpływ na uzgodnienie',
  'bank.importFix.deviationNow': 'Obecna różnica:',
  'bank.importFix.afterCorrection': 'Po korekcie:',
  'bank.importFix.stillDeviates': 'Jeśli różnica nadal występuje, sprawdź, czy BO/BZ również nie zostały odczytane błędnie.',
  'bank.importFix.fixLine': 'Popraw pozycję',
  'bank.importFix.removeMisread': 'Ignoruj pozycję',
  'bank.ignoreLine': 'Ignoruj pozycję',
  'bank.ignoreLineHelp': 'Używaj tego tylko wtedy, gdy pozycja została błędnie odczytana i nie występuje w wyciągu bankowym. Pozycja pozostaje w historii.',
  'bank.ignoreLineConfirm': 'Ignoruj pozycję',
  'bank.ignoreLineReason': 'Dlaczego pozycja jest ignorowana?',
  'bank.ignoreLineReasonHint': 'Wymagane dla ścieżki audytu.',
  'bank.ignoreLineReasonPlaceholder': 'Np. pozycja nie występuje w wyciągu bankowym',
  'bank.importFix.removeNote': 'Pozycja pozostaje w historii, ale liczy się jako 0,00 kr i jest traktowana jako zakończona w uzgodnieniu. Używaj tylko, gdy pozycja nie występuje w wyciągu bankowym.',
  'bank.importFix.whyReading': 'Dlaczego odczyt jest poprawiany?',
  'bank.importFix.whyReadingPh': 'Np. OCR odczytał błędną kwotę / pozycja nie występuje w wyciągu bankowym',
  'bank.importFix.err.balancesNumber': 'BO i BZ muszą być liczbami.',
  'bank.importFix.err.reasonBalance': 'Napisz krótko, dlaczego saldo jest poprawiane.',
  'bank.importFix.saveBalance': 'Zapisz saldo',
  'bank.importFix.balanceWarnTitle': 'Zmieniaj tylko wtedy, gdy saldo z wyciągu/importu jest błędne.',
  'bank.importFix.balanceWarnBody': 'BO jest zwykle pobierane z poprzedniego uzgodnionego BZ. Pierwotnie odczytane saldo zostaje zachowane.',
  'bank.importFix.resultPrefix': 'Przy obecnie przetworzonych pozycjach bankowych różnica salda wynosi',
  'bank.importFix.whyBalance': 'Dlaczego saldo jest poprawiane?',
  'bank.importFix.whyBalancePh': 'Np. BZ zostało odczytane z niewłaściwego wiersza w PDF',
  'bank.loan.intro': 'Użyj tego dla zaciągnięcia kredytu, spłat rat lub płatności, które można podzielić na kapitał, odsetki i opłaty. Wybrane konto pochodzi z aktywnego planu kont firmy, a księgowanie odbywa się bez VAT.',
  'bank.loan.account': 'Konto kredytu/zobowiązania',
  'bank.loan.noAccount': 'Nie znaleziono zwykłego konta kredytu/zobowiązania w aktywnym planie kont. Utwórz właściwe konto lub użyj księgowania swobodnego.',
  'bank.loan.principal': 'Rata kapitałowa / kwota kredytu',
  'bank.loan.splitMismatch': 'Podział musi zgadzać się z kwotą bankową. Pozostało: {{amount}} kr.',
  'bank.loan.docLinked': 'Dokumentacja jest powiązana.',
  'bank.loan.docRemember': 'Pamiętaj o dokumentacji.',
  'bank.loan.docHelp': 'Prześlij umowę kredytu, harmonogram spłat lub inne dokumenty. Podział musi dać się udokumentować.',
  'bank.loan.complex': 'Czy pozycja dotyczy podmiotu powiązanego, nietypowego konta lub bardziej złożonego kredytu?',
  'bank.loan.useFree': 'Użyj dowolnego księgowania',
  'bank.group.err.sameDirection': 'Wszystkie linie bankowe w grupie podziału muszą mieć ten sam kierunek.',
  'bank.group.err.pickBoth': 'Wybierz obie linie bankowe przelewu.',
  'bank.group.toast.transferApproved': 'Przelew został zatwierdzony i zaksięgowany łącznie.',
  'bank.group.toast.allocationApproved': 'Podział został zatwierdzony i zaksięgowany łącznie.',
  'bank.group.err.approveFailed': 'Nie udało się zatwierdzić grupy dopasowania.',
  'bank.group.title': 'Dopasuj kilka operacji bankowych',
  'bank.group.approve': 'Zatwierdź i zaksięguj grupę',
  'bank.group.oneOperation': 'Jedna kontrolowana operacja',
  'bank.group.oneOperationHelp': 'Grupa rezerwuje wszystkie wybrane linie bankowe. Księgowanie i powiązanie odbywają się łącznie na serwerze po zatwierdzeniu.',
  'bank.group.matchType': 'Typ dopasowania',
  'bank.group.typeAllocation': 'Rozdziel płatność na otwarte pozycje',
  'bank.group.typeTransfer': 'Przelew wewnętrzny między własnymi rachunkami',
  'bank.group.sourceLine': 'Linia z jednego rachunku',
  'bank.group.counterLine': 'Przeciwstawna pozycja na własnym rachunku',
  'bank.group.pickOpposite': 'Wybierz przeciwną linię bankową',
  'bank.group.transferRules': 'Proponowane są tylko linie z tą samą datą i kwotą, przeciwnym znakiem i na innym skonfigurowanym rachunku bankowym. Różne daty wymagają konta technicznego (tranzytowego).',
  'bank.group.noOpenItems': 'Brak otwartych pozycji ({{kind}}) do rozliczenia.',
  'bank.group.customerInvoices': 'faktury klientów',
  'bank.group.supplierInvoices': 'faktury dostawców',
  'bank.group.itemRest': '{{number}} · {{party}} · pozostało {{amount}}',
  'bank.group.removeRow': 'Usuń wiersz',
  'bank.corr.err.reasonVoid': 'Napisz krótko, dlaczego księgowanie jest anulowane.',
  'bank.corr.err.notFieldCorrectable': 'Tego typu pozycji nie można poprawiać pole po polu z poziomu uzgodnienia bankowego. Anuluj księgowanie i zaksięguj je ponownie poprawnie albo otwórz dokument w dzienniku dokumentów.',
  'bank.corr.err.supplierPaymentVoid': 'Płatności faktur dostawców anuluje się z poziomu dokumentu dostawcy.',
  'bank.corr.err.noSupportedAction': 'Nie znaleziono obsługiwanego działania dla tej zaksięgowanej pozycji.',
  'bank.receipt.toast.trashed': 'Dokument został przeniesiony do kosza.',
  'bank.receipt.err.deleteFailed': 'Nie udało się usunąć dokumentu.',
  'bank.receipt.deleting': 'Usuwanie…',
  'bank.receipt.delete': 'Usuń dokument',
  'bank.mode.toFull': 'Przełącz na pełny widok',
  'bank.mode.toGuided': 'Przełącz na tryb krok po kroku',
  'bank.import.toast.privateSaved': 'Wyciąg prywatny zapisany - gotowy do przeglądu',
  'bank.import.toast.saved': 'Wyciąg bankowy zapisany - gotowy do uzgodnienia',
  'bank.inbox.view.statement': 'Ten wyciąg',
  'bank.inbox.view.unlinked': 'Tylko niepowiązane',
  'bank.inbox.view.all': 'Wszystkie dokumenty',
  'bank.inbox.showInList': 'Pokaż w skrzynce odbiorczej',
  'bank.inbox.viewing': 'Widok: {{view}} · ukryte: {{hidden}}',
  'bank.inbox.waiting': 'Dokumenty czekające na obsługę: {{count}}',
  'bank.inbox.hide': 'Ukryj skrzynkę odbiorczą',
  'bank.inbox.companyAddress': 'skrzynkę dokumentów firmy',
  'bank.inbox.defaultNote': 'Przeciągnij dokument na linię bankową albo pozwól SuperPlummie zaproponować dopasowania.',
  'bank.inbox.uploadVoucher': 'Prześlij dokument',
  'bank.inbox.orDrag': 'Lub przeciągnij · upuść na linię bez dokumentu',
  'bank.inbox.dropHint': 'Upuść pliki tutaj, aby przesłać nowe dokumenty.',
  'bank.inbox.noMatch': 'Żaden dokument nie pasuje do wyszukiwania.',
  'bank.inbox.noneInSelection': 'Brak dokumentów w tym wyborze · ukryte przez filtr: {{hidden}}',
  'bank.inbox.allDone': 'Wszystkie dokumenty zostały obsłużone',
  'bank.inbox.empty': 'Skrzynka odbiorcza jest pusta',
  'bank.inbox.tip.showAll': 'Kliknij, aby ponownie wyświetlić wszystkie linie bankowe',
  'bank.inbox.tip.showLine': 'Kliknij, aby wyświetlić linię bankową powiązaną z tym dokumentem',
  'bank.inbox.tip.linkedElsewhere': 'Powiązano poza tym wyciągiem bankowym',
  'bank.inbox.linkedHere': 'Powiązano · {{label}}',
  'bank.inbox.linkedIn': 'Powiązano w {{label}}',
  'bank.inbox.previewName': 'Podgląd {{name}}',
  'bank.inbox.voucherLower': 'dokument',
  'bank.inbox.filteredOne': 'Filtr: jeden dokument',
  'bank.inbox.filteredN': 'Filtr: dokumenty ({{count}})',
  'bank.inbox.filterShowsLinked': 'Pokazuje tylko linie bankowe powiązane z dokumentami',
  'bank.inbox.showAllLines': 'Pokaż wszystkie linie',
  'bank.inbox.nBankLines': 'Linie bankowe: {{count}}',
  'bank.inbox.bankLineLower': 'linia bankowa',
  'bank.inbox.anotherStatement': 'innym wyciągu bankowym',
  'bank.inbox.toast.linkedElsewhere': 'Dokument jest powiązany z linią bankową w {{label}}.',
  'bank.resolve.annulText': 'Pozycja jest zaksięgowana podwójnie. Wystornuj ją, aby nie była uwzględniana. Ewentualny dokument wróci automatycznie do skrzynki odbiorczej.',
  'bank.resolve.correctText': 'Księgowanie ma pozostać, ale konto, VAT lub opis wewnętrzny są błędne. Kwota bankowa i data pozostają zablokowane.',
  'bank.resolve.err.voidFailed': 'Nie udało się anulować zaksięgowanej pozycji.',
  'bank.resolve.voiding': 'Anulowanie…',
  'bank.resolve.confirmVoid': 'Potwierdź anulowanie',
  'bank.resolve.voidReason': 'Powód anulowania',
  'bank.resolve.voidReasonHint': 'Wymagane. Uzasadnienie zostanie zapisane w ścieżce audytu.',
  'bank.resolve.voidReasonPh': 'Opisz krótko, dlaczego księgowanie ma zostać anulowane',
  'bank.resolve.row.postedEntry': 'Zaksięgowana pozycja',
  'bank.resolve.row.account': 'Konto',
  'bank.resolve.row.vat': 'VAT',
  'bank.resolve.row.amount': 'Kwota',
  'bank.resolve.row.lineDate': 'Data linii bankowej',
  'bank.resolve.row.bankLine': 'Linia bankowa',
  'bank.resolve.row.voucher': 'Dokument',
  'bank.resolve.row.notLinked': 'Niepowiązane',
  'bank.resolve.reopenAsDeviation': 'Otwórz jako odchylenie',
  'bank.resolve.releaseInvestmentMatch': 'Zwolnij powiązanie bankowe',
  'bank.resolve.reverse': 'Wystornuj',
  'bank.resolve.alreadyPosted': 'Ta linia bankowa jest już zaksięgowana lub dopasowana. Nie można jej więc obsłużyć jako nowej linii.',
  'bank.resolve.useCorrection': 'Użyj korekty dla konta, VAT lub opisu wewnętrznego. Kwota bankowa, data i powiązanie pozostają zablokowane.',
  'bank.resolve.reverseInfo': 'Storno anuluje zakup z zachowaniem śladu i otwiera linię bankową do ponownej kontroli.',
  'bank.resolve.existingInfo': 'Jest to powiązane z istniejącym dokumentem lub pozycją. Popraw sam dokument, jeśli podstawa jest błędna.',
  'bank.resolve.verifiableInfo': 'To powiązanie można zweryfikować w szczegółach pozycji.',
  'bank.resolve.approving': 'Zatwierdzanie…',
  'bank.resolve.approveN': 'Zatwierdź propozycje ({{count}})',
  'bank.resolve.confirmIntro': 'Sprawdź podsumowanie. Propozycje dopasowane do istniejącej pozycji nie tworzą nowego księgowania.',
  'bank.resolve.voucherReturns': 'Dokument „{{name}}” wróci automatycznie do skrzynki odbiorczej po anulowaniu pozycji.',
  'bank.err.uploadVoucherFailed': 'Nie udało się przesłać dokumentu.',
  'bank.drop.attachAsDoc': 'Zostanie dołączony jako dokumentacja',
  'bank.drop.uploadAnalyzeLink': 'Zostanie przesłany, przeanalizowany i powiązany',
  'bank.receipt.confirmDelete': 'Usunąć dokument ze skrzynki odbiorczej? Zostanie przeniesiony do kosza i można go przywrócić.',
  'bank.percentDone': 'Ukończono {{pct}}%',
  'mypage.role.owner': 'Właściciel',
  'mypage.role.admin': 'Administrator',
  'mypage.role.accountant': 'Księgowy',
  'mypage.role.viewer': 'Czytelnik',
  'mypage.shortcut.oversikt.title': 'Przegląd',
  'mypage.shortcut.oversikt.text': 'Wskaźnik kondycji i przegląd finansów gospodarstwa domowego',
  'mypage.shortcut.forbruk.title': 'Wydatki',
  'mypage.shortcut.forbruk.text': 'Na co idą pieniądze, w podziale na kategorie',
  'mypage.shortcut.familie.title': 'Rodzina',
  'mypage.shortcut.familie.text': 'Wspólny budżet i podział w gospodarstwie domowym',
  'mypage.shortcut.fremtid.title': 'Przyszłość',
  'mypage.shortcut.fremtid.text': 'Oszczędności, kredyty, emerytura i plany na przyszłość',
  'mypage.shortcut.skatt.title': 'Podatki',
  'mypage.shortcut.skatt.text': 'Prywatna skattemelding, ulgi i szacunek',
  'mypage.fallback.business': 'Firma',
  'mypage.fallback.signedInUser': 'Zalogowany użytkownik',
  'mypage.fallback.employerLoadError': 'Nie udało się pobrać pracodawców.',
  'mypage.verify.body': 'Niektóre funkcje, m.in. zaproszenia klientów i portal pracownika, wymagają potwierdzenia adresu {{email}}. Wyślij link ponownie, jeśli nie możesz go znaleźć, otwórz link w e-mailu, a następnie potwierdź tutaj.',
  'mypage.verify.resend': 'Wyślij potwierdzenie ponownie',
  'mypage.verify.sending': 'Wysyłanie...',
  'mypage.verify.confirmed': 'Potwierdziłem',
  'mypage.verify.checking': 'Sprawdzanie...',
  'mypage.err.profileNotConnected': 'Zapisywanie profilu nie jest połączone z serwerem.',
  'mypage.toast.profileUpdated': 'Profil został zaktualizowany',
  'mypage.err.profileUpdateFailed': 'Nie udało się zaktualizować profilu.',
  'mypage.err.verifyNotConnected': 'Potwierdzanie e-maila nie jest połączone z serwerem.',
  'mypage.toast.alreadyVerified': 'Adres e-mail jest już potwierdzony.',
  'mypage.toast.verifyResent': 'Link potwierdzający został wysłany ponownie.',
  'mypage.err.verifySendFailed': 'Nie udało się wysłać linku potwierdzającego.',
  'mypage.err.verifyStatusFailed': 'Nie udało się sprawdzić statusu e-maila.',
  'mypage.toast.emailVerified': 'Adres e-mail został potwierdzony.',
  'mypage.toast.stillUnverified': 'Adres nadal nie jest potwierdzony. Sprawdź skrzynkę odbiorczą i spróbuj ponownie.',
  'mypage.err.personalNotConnected': 'Finanse osobiste nie są połączone z serwerem w tej wersji.',
  'mypage.toast.personalCreated': 'Finanse osobiste zostały utworzone',
  'mypage.err.personalCreateFailed': 'Nie udało się utworzyć finansów osobistych.',
  'mypage.toast.openPersonalForFamily': 'Otwórz Finanse osobiste, aby zmienić Rodzinę.',
  'mypage.toast.familyEnabled': 'Rodzina jest włączona.',
  'mypage.toast.familyDisabled': 'Rodzina jest wyłączona.',
  'mypage.err.familySaveFailed': 'Nie udało się zapisać ustawienia Rodzina.',
  'mypage.titleHelp': 'Moja strona to Twoje osobiste konto w Plumme – oddzielone od samych ksiąg. Widzisz tu swój profil, firmy, do których masz dostęp, pracodawców, u których jesteś zatrudniony, oraz wejście do finansów osobistych.',
  'mypage.field.memberSince': 'Członek od',
  'mypage.toast.onboardingNotLoaded': 'Wdrożenie nie zostało jeszcze wczytane.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Pobieranie firm',
  'mypage.biz.loadingText': 'Łączenie z serwerem Plumme.',
  'mypage.biz.emptyTitle': 'Brak własnych firm',
  'mypage.biz.emptyText': 'Możesz później utworzyć tu firmę, także jeśli korzystasz z Plumme tylko jako księgowy lub użytkownik prywatny.',
  'mypage.clients.title': 'Zlecenia klientów',
  'mypage.clients.help': 'Firmy, do których zaproszono Cię jako księgowego, administratora lub czytelnika. Dane klientów są oddzielone od własnych firm i Finansów osobistych.',
  'mypage.clients.setup': 'Konfiguracja księgowego',
  'mypage.clients.access': 'Dostęp do klientów',
  'mypage.clients.empty': 'Nie masz aktywnych zleceń klientów. Zaproszenia są wyświetlane globalnie po zalogowaniu.',
  'mypage.pf.creating': 'Tworzenie...',
  'mypage.pf.create': 'Utwórz finanse osobiste',
  'mypage.pf.intro': 'Twój osobisty doradca finansów domowych - oddzielony od księgowości firm. Wybierz widok, aby zacząć.',
  'mypage.pf.family': 'Rodzina',
  'mypage.pf.familyText': 'Pokaż stronę Rodzina w Finansach osobistych.',
  'mypage.pf.emptyIntro': 'Utwórz klienta Finansów osobistych, aby zebrać prywatny przegląd, import, gospodarstwo domowe, podatki i raporty bez mieszania ich z klientami księgowymi.',
  'mypage.emp.fallbackRole': 'Pracownik',
  'mypage.emp.loadingTitle': 'Pobieranie pracodawców',
  'mypage.emp.emptyTitle': 'Brak pracodawców',
  'mypage.emp.loadingText': 'Łączenie z portalem pracownika.',
  'mypage.emp.emptyText': 'Dla tego użytkownika nie zarejestrowano dostępów do portalu pracownika.',
  'mypage.err.passwordResetNotConnected': 'Resetowanie hasła nie jest połączone z serwerem.',
  'mypage.toast.passwordLinkSent': 'Link do zmiany hasła został wysłany e-mailem',
  'mypage.err.passwordLinkFailed': 'Nie udało się wysłać linku do hasła.',
  'mypage.saving': 'Zapisywanie...',
  'mypage.hh.loadError': 'Nie udało się pobrać powiązania gospodarstwa domowego.',
  'mypage.hh.updateError': 'Nie udało się zaktualizować gospodarstwa domowego.',
  'mypage.hh.inviteEmailFailed': 'Zaproszenie zostało utworzone, ale nie udało się wysłać e-maila. Możesz spróbować ponownie.',
  'mypage.hh.inviteSent': 'Zaproszenie zostało utworzone i wysłane.',
  'mypage.hh.left': 'Powiązanie gospodarstwa domowego zostało zakończone.',
  'mypage.hh.hiddenPending': 'Zaproszenie zostało wycofane i usunięte z listy.',
  'mypage.hh.hidden': 'Zaproszenie zostało usunięte z listy.',
  'mypage.hh.loading': 'Pobieranie statusu gospodarstwa domowego …',
  'mypage.hh.partnerFallback': 'Połączony partner',
  'mypage.hh.twoAccounts': 'Dwa oddzielne konta · wspólna strona Rodzina',
  'mypage.hh.leaveConfirm': 'Odłączyć gospodarstwo domowe? Obie osoby zachowują własne dane, a wspólny profil Rodzina zostanie zakończony.',
  'mypage.hh.leaving': 'Odłączanie …',
  'mypage.hh.leave': 'Odłącz gospodarstwo domowe',
  'mypage.hh.inviteIntro': 'Zaproś partnera e-mailem. Odbiorca może się zalogować lub utworzyć nowe konto Plumme i otrzyma pomoc w utworzeniu Finansów osobistych, zanim powiązanie zostanie zatwierdzone.',
  'mypage.hh.inviting': 'Tworzenie …',
  'mypage.hh.invite': 'Zaproś partnera',
  'mypage.hh.userFallback': 'Użytkownik Plumme',
  'mypage.hh.joined': 'Gospodarstwo domowe zostało połączone.',
  'mypage.hh.sentInvites': 'Wysłane zaproszenia',
  'mypage.hh.resendFailedToast': 'Zaproszenie jest aktywne, ale nie udało się wysłać e-maila.',
  'mypage.hh.resentToast': 'Zaproszenie zostało wysłane ponownie.',
  'mypage.hh.resend': 'Wyślij ponownie',
  'mypage.hh.remind': 'Przypomnij',
  'mypage.hh.withdrawn': 'Zaproszenie zostało wycofane.',
  'mypage.hh.removeFromList': 'Usuń z listy',
  'mypage.hh.status.pending': 'Oczekuje na odpowiedź · {{delivery}}',
  'mypage.hh.status.expired': 'Wygasło',
  'mypage.hh.status.declined': 'Odrzucono',
  'mypage.hh.status.canceled': 'Wycofano',
  'mypage.hh.status.accepted': 'Zaakceptowano',
  'mypage.hh.delivery.delivered': 'e-mail dostarczony',
  'mypage.hh.delivery.opened': 'e-mail otwarty',
  'mypage.hh.delivery.clicked': 'link otwarty',
  'mypage.hh.delivery.failed': 'błąd e-maila',
  'mypage.hh.delivery.bounced': 'e-mail odrzucony',
  'mypage.hh.delivery.complained': 'oznaczono jako spam',
  'mypage.hh.delivery.delivery_delayed': 'e-mail opóźniony',
  'mypage.hh.delivery.sent': 'e-mail wysłany',
  'audit.domain.settings': 'Ustawienia',
  'audit.domain.invoices': 'Faktury',
  'audit.domain.sales': 'Sprzedaż',
  'audit.domain.expenses': 'Zakupy',
  'audit.domain.customers': 'Klienci',
  'audit.domain.products': 'Produkty',
  'audit.domain.suppliers': 'Dostawcy',
  'audit.domain.inbox': 'Skrzynka odbiorcza',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Ewidencja przebiegu',
  'audit.domain.payroll': 'Płace',
  'audit.domain.business': 'Firma',
  'audit.domain.access': 'Dostępy',
  'audit.summary.rows': 'Wiersze: {{count}}',
  'audit.summary.fields': 'Pola: {{count}}',
  'audit.event.updated': 'Zaktualizowano: {{domains}}',
  'audit.event.updatedBusinessData': 'Zaktualizowano dane firmy',
  'audit.event.businessCreated': 'Utworzono firmę',
  'audit.event.inviteCreated': 'Zaproszono {{email}} jako {{role}}',
  'audit.event.inviteAccepted': '{{user}} zaakceptował(a) zaproszenie',
  'audit.event.deletionRequestedFor': 'Zażądano usunięcia firmy {{date}}',
  'audit.event.deletionRequested': 'Zażądano usunięcia firmy',
  'audit.event.deletionCanceled': 'Anulowano usunięcie firmy',
  'audit.fallback.newUser': 'nowy użytkownik',
  'audit.fallback.userLower': 'użytkownik',
  'audit.fallback.user': 'Użytkownik',
  'audit.fallback.unknownUser': 'Nieznany użytkownik',
  'audit.err.loadFailed': 'Nie udało się pobrać dziennika aktywności.',
  'audit.meta.time': 'Czas',
  'audit.meta.user': 'Użytkownik',
  'audit.meta.role': 'Rola',
  'audit.meta.action': 'Działanie',
  'audit.meta.source': 'Źródło',
  'audit.meta.invite': 'Zaproszenie',
  'audit.meta.targetUser': 'Użytkownik docelowy',
  'audit.detail.before': 'Przed:',
  'audit.detail.after': 'Po:',
  'audit.titleHelp': 'Dziennik aktywności to ścieżka audytu: pokazuje wszystkie ważne działania w księgowości - kto, co, kiedy i w jakim obszarze zrobił. Przydatny dla identyfikowalności i kontroli, gdy współpracuje kilka osób.',
  'audit.search': 'Szukaj w dzienniku aktywności za {{year}}',
  'audit.scope.all': 'Wszystkie',
  'audit.scope.others': 'Inni',
  'audit.scope.mine': 'Ja',
  'audit.scope.access': 'Dostępy',
  'audit.col.event': 'Zdarzenie',
  'audit.empty.loadingTitle': 'Pobieranie dziennika aktywności',
  'audit.empty.loadingText': 'Łączenie z serwerem Plumme.',
  'audit.empty.noMatchTitle': 'Brak wyników',
  'audit.empty.noMatchText': 'Żadna aktywność nie pasuje do filtra. Spróbuj go wyczyścić.',
});
